import { gql } from "@apollo/client";

export const ENUM_LABEL_VALUE = gql(`query($type:String!){__type(name:$type){enumValues{value:name label:description}}}`)